import type { ManufactureCourse } from "../constant/manufactureCourse"
import MANUFACTURE_COURSE from "../constant/manufactureCourse"
import type EstimateValues from "../types/params"
import { isRigid } from "./oneClickIs"

/**
 * デリバリーゼロでの見積依頼が可能か否かを返す。項目の選択可否や、項目が選択されているかは関係ない。
 * <br/>
 * ※ 製造コース省略時はコースに対するチェックを実施しない（見積計算時は全コースまとめて見積を行う仕様を考慮）
 *
 * @param values 見積項目の値
 * @param manufactureCourse 製造コース
 */
const isDeliveryZeroAvailable = (values: EstimateValues, manufactureCourse?: ManufactureCourse) => {
  const courseValid = manufactureCourse ? manufactureCourse === MANUFACTURE_COURSE.ultraQuick : true

  return courseValid && isRigid(values) && !values.serviceG
}

export default isDeliveryZeroAvailable
